import { createFileRoute } from '@tanstack/react-router'

import { AdminSidebarContainer } from '@/components/app/admin-sidebar-container'
import { OcrDatasetWorkflow } from '@/components/screens/ocr-datasets/ocr-dataset-workflow'

// OCR教師データはバックエンド未実装（20260820_03 の C 分類）のため、画面は v0 モックのまま。
// ただし AdminSidebar を出す管理コンソール画面が /ocr-datasets として未認証で開けてしまっていたため、
// Phase 3 で /admin 配下へ移し admin ロールガードの内側に入れた
// （メニューを非活性に落とすかどうかの判断は Phase 5。docs/issues/20260821_01 参照）
function OcrDatasetsPage() {
  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebarContainer />
      <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-8 xl:px-10">
        <div className="mx-auto w-full max-w-[1680px]">
          <OcrDatasetWorkflow />
        </div>
      </main>
    </div>
  )
}

export const Route = createFileRoute('/admin/ocr_datasets')({
  component: OcrDatasetsPage,
})
